export default "__VITE_ASSET__DYayXAGH__"